var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var BufferList = require('bl/BufferList');

module.exports = function (source) {
  var reader = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var bytes, bl, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return;

          case 2:
            bytes = _context.sent;
            // Allows us to receive 8 when reader.next(8) is called
            bl = new BufferList();
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 6;
            _iterator = _asyncIterator(source);

          case 8:
            _context.next = 10;
            return _awaitAsyncGenerator(_iterator.next());

          case 10:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 37;
              break;
            }

            chunk = _step.value;

            if (bytes) {
              _context.next = 18;
              break;
            }

            _context.next = 15;
            return bl.append(chunk);

          case 15:
            bytes = _context.sent;
            bl = new BufferList();
            return _context.abrupt("continue", 34);

          case 18:
            bl.append(chunk);

          case 19:
            if (!(bl.length >= bytes)) {
              _context.next = 34;
              break;
            }

            data = bl.shallowSlice(0, bytes);
            bl.consume(bytes);
            _context.next = 24;
            return data;

          case 24:
            bytes = _context.sent;

            if (bytes) {
              _context.next = 32;
              break;
            }

            if (!bl.length) {
              _context.next = 31;
              break;
            }

            _context.next = 29;
            return bl;

          case 29:
            bytes = _context.sent;
            bl = new BufferList();

          case 31:
            return _context.abrupt("break", 34);

          case 32:
            _context.next = 19;
            break;

          case 34:
            _iteratorAbruptCompletion = false;
            _context.next = 8;
            break;

          case 37:
            _context.next = 43;
            break;

          case 39:
            _context.prev = 39;
            _context.t0 = _context["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 43:
            _context.prev = 43;
            _context.prev = 44;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 48;
              break;
            }

            _context.next = 48;
            return _awaitAsyncGenerator(_iterator.return());

          case 48:
            _context.prev = 48;

            if (!_didIteratorError) {
              _context.next = 51;
              break;
            }

            throw _iteratorError;

          case 51:
            return _context.finish(48);

          case 52:
            return _context.finish(43);

          case 53:
            if (!bytes) {
              _context.next = 55;
              break;
            }

            throw Object.assign(new Error("stream ended before ".concat(bytes, " bytes became available")), {
              code: 'ERR_UNDER_READ',
              buffer: bl
            });

          case 55:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 39, 43, 53], [44,, 48, 52]]);
  }))();

  reader.next();
  return reader;
};